import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import tc from "i18n/tc";
import sc from "i18n/sc";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tc: { translation: tc },
      sc: { translation: sc },
    },
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
